import React from "react";
import moment from "moment";
import CardEmpty from "Utils/Cards/CardEmpty";
import DatePicker from "react-datepicker";
import TimePicker from "react-time-picker";

export const FechaHoraAnalisis = ({
    fechaAnalisis,
    setFechaAnalisis,
    horaAnalisis,
    setHoraAnalisis,
    isModoAnalisis,
}) => {
    return (
        <CardEmpty noShadow noPadding>
            <div className="col-12 m-0 py-3 d-flex flex-wrap justify-content-between">
                <div className="row col-md-12 p-0 d-flex flex-wrap align-items-end">
                    <div className="col-lg-6 p-0">
                        <div className="col-12">
                            <label htmlFor="fecha_analisis" className="m-0">
                                FECHA DE INICIO DE LABORATORIO
                            </label>
                        </div>
                        <div className="col-lg-12  form-group">
                            <DatePicker
                                showPopperArrow
                                dateFormat={"DD/MM/YYYY"}
                                placeholderText={"Fecha de inicio"}
                                onChange={(e) => {
                                    setFechaAnalisis(e);
                                }}
                                selected={fechaAnalisis}
                                maxDate={moment()}
                                todayButton={"Hoy"}
                                className="form-control"
                                disabled={!isModoAnalisis}
                            />
                        </div>
                    </div>
                    <div className="col-lg-6 p-0">
                        <div className="col-12">
                            <label htmlFor="hora_analisis" className="m-0">
                                HORA DE INICIO DE LABORATORIO
                            </label>
                        </div>
                        <div className="col-lg-12  form-group">
                            {!isModoAnalisis ? (
                                <input
                                    type="time"
                                    className="form-control text-center"
                                    value={horaAnalisis}
                                    disabled
                                />
                            ) : (
                                <TimePicker
                                    maxDetail="minute"
                                    locale="en-US"
                                    disableClock={true}
                                    clearIcon={null}
                                    onChange={(value) => setHoraAnalisis(value)}
                                    value={horaAnalisis}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </CardEmpty>
    );
};
